export default __webpack_public_path__ + "static/office3-2x-33c5eadadb6058857dbb2dff584ae6f2.jpg";